/**
 * Route for `localized-region-specific-dns-cdn-edge`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { LocalizedRegionSpecificDnsCdnEdgePage } from "../features/localized-region-specific-dns-cdn-edge/LocalizedRegionSpecificDnsCdnEdgePage";

export const localizedRegionSpecificDnsCdnEdgeRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/localized-region-specific-dns-cdn-edge",
	component: LocalizedRegionSpecificDnsCdnEdgePage,
});

export default localizedRegionSpecificDnsCdnEdgeRoute;
